import { CurrencyUtil } from "@mcleod/core";
import { Component } from "../..";
import { Layout } from "../../components/layout/Layout";
import { TooltipSource } from "./TooltipSource";
import { TooltipSourceType } from "./TooltipSourceType";

export class CurrencyExchangeInfoTooltipSource extends TooltipSource {
    public static readonly EXCHANGE_INFO_LAYOUT_PATH = "lme/general/multicurrency/ExchangeRateQuickInfo";
    private readonly anchorComponent: Component;

    constructor(anchorComponent: Component) {
        super(TooltipSourceType.CURRENCY_EXCHANGE_INFO, null);
        this.content = this.createExchangeLayout;
        this.anchorComponent = anchorComponent;
    }

    private createExchangeLayout: () => Promise<Layout> = async () => {
        const currentCurrency = CurrencyUtil.getCurrencyObjectFromDataValue(this.anchorComponent.getDataValue());
        const exchangeLayout =
            await Layout.getLoadedLayout(CurrencyExchangeInfoTooltipSource.EXCHANGE_INFO_LAYOUT_PATH);
        await exchangeLayout.mainDataSource?.search({ currency_for_exchange: currentCurrency });
        return exchangeLayout;
    }
}
